define('lq/guidChecker',[ ], function () {
    'use strict';

    var isGuidAndNotEmpty = function (guid) {
        const regex = /^(?!(?:00000000-0000-0000-0000-000000000000)$)[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return regex.test(guid);
    };

    var isGuidOrEmpty = function (guid) {
        const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        return regex.test(guid);
    };

    var isEmptyGuid = function (guid) {
        return guid === '00000000-0000-0000-0000-000000000000';
    };

    var areEqual = function (guid1, guid2) {
        if (!isGuidOrEmpty(guid1) || !isGuidOrEmpty(guid2))
            return false;
        return guid1.toLowerCase() === guid2.toLowerCase();
    };

    return {
        isGuidAndNotEmpty: isGuidAndNotEmpty,
        isGuidOrEmpty: isGuidOrEmpty,
        isEmptyGuid: isEmptyGuid,
        areEqual: areEqual
    };
});

